import { ComponentProps } from 'react';

import { Avatar, AvatarImage, Button, Typography } from '@/shared/ui';

import { IAvatar } from '../model/types';

interface AvatarCardProps extends ComponentProps<typeof Button> {
  avatar: IAvatar;
  isActive: boolean;
}
export const AvatarCard = ({ avatar, isActive, ...props }: AvatarCardProps) => {
  return (
    <Button
      variant={isActive ? 'base-100' : 'base-300'}
      className="flex-col gap-y-2 rounded-[100px] px-2 pb-6 pt-5"
      {...props}
    >
      <Avatar className="h-20 w-20 border border-graphite">
        <AvatarImage src={avatar.imageSrc} alt="avatar" />
      </Avatar>
      <Typography variant="14-r" color="text-base-100">
        {avatar.name}
      </Typography>
    </Button>
  );
};
